import React from 'react'
import styled from 'styled-components'
import {Paragraph} from 'common/components'
import {TransactionCheckoutInfoItemProps} from './TransactionInfoItemProps'

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  width: 50%;
`

export default function PaymentHistoryInfoItem({
  title,
  description,
  totalPrice,
  boldDescription,
  details,
  ...props
}: TransactionCheckoutInfoItemProps) {
  return details ? (
    <StyledContainer {...props}>
      <Paragraph color="gray_4">{title}</Paragraph>
      <Paragraph color="gray_4">{description}</Paragraph>
    </StyledContainer>
  ) : (
    <StyledContainer {...props}>
      <Paragraph fontSize="m" fontWeight="medium">
        {title}
      </Paragraph>
      <Paragraph
        fontSize="m"
        fontWeight={boldDescription ? 'bold' : 'regular'}
        color={totalPrice ? 'primary_5' : 'black'}>
        {description}
      </Paragraph>
    </StyledContainer>
  )
}
